
import copy from 'copy-to-clipboard'
import store from '@/store';
import Vue from 'vue'
import CostGuardNotice from '@/components/CostGuardNotice.vue'
import IntroDrawer from '@/components/IntroDrawer.vue'
import { introContext, publicIntro, introButtonText, resultsRendered } from '@/utils/intro'
import { costGuardCode } from '@/utils/guestSession'
import { FiltersInput, Match, MatchFiltersDto, MatchRequest, MatchResultsDto, ProfileUpdatedRequest, SharingRequest, MatchMatchDirectionEnum, UserDto, UnitDto } from '@chainsight/networker-backend-axios-sdk';
import MainLayout from '@/components/MainLayout.vue'
import userManager from '@/user-manager';
import { Editor } from '@toast-ui/vue-editor';
import i18n from '@/plugins/i18n'
import { translateTexts, translateMatches, translateRecordValues, translateMatch } from '@/utils/translator'
import { getGuestMatchRequest } from '@/utils/guest-match-request'
import { el, it } from 'date-fns/locale';
import formatRelativeWithOptions from 'date-fns/fp/formatRelativeWithOptions/index';

export default Vue.extend({
	name: 'NonLoginBusinessMatchResults',
	components: { CostGuardNotice, IntroDrawer,
		MainLayout,
		// editor: Editor,
	},
	data() {
		return {
            costCode: '',
            introOpen: false,
            introContextData: {} as any,
			MatchMatchDirectionEnum,
			overlay: false,
            matchContextReady: Promise.resolve() as Promise<void>,
            resultRequestSequence: 0,
            resultTranslationSequence: 0,
            resultsDestroyed: false,
            loadError: false,
            detailError: false,
			writeMessageDialog: false,
			emailDialog: false,
			isCopied: false,
			isRequiredImageError: false,
			isFilterBarOpen: true,
			detailDrawer: false,
			mobileDetailDrawer: false,
			loginPromptDialog: false,
			loginPromptDialogSource: 'default' as 'default' | 'refine',
			detailDrawerTimer: null as any,
			detailRequestSequence: 0,
			currentDetailItem: null as any,
			isFilterDialogOpen: false,
			infoDialog: false,
			sharingDialog: false,
			isSupplyDescExpanded: false,
			isDemandDescExpanded: false,
			isHasStructuredProfile: 'all',
			resultNumbers: 0,
			allowResults: 0,
			firstName: '',
			lastName: '',
			jobTitle: '',
			companyName: '',
			companyWebsiteUrl: '',
			emailContentMarkdownForEdit: '',
			sharingUrl: '',
			countriesUpperBound: 3,
			industriesUpperBound: 3,
			matchDirectionsUpperBound: 3,
			matchQueriesUpperBound: 3,
			regionsUpperBound: 3,
			typesUpperBound: 3,
			timeStrings: [] as string[],
			utcTimeStrings: [] as string[],
			demandDescriptions: [] as string[],
			supplyDescriptions: [] as string[],
			countries: [] as string[],
			industries: [] as string[],
			matchDirections: [] as string[],
			matchQueries: [] as string[],
			regions: [] as string[],
			types: [] as string[],
			allCountries: [] as string[],
			allMatchQueries: [] as string[],
			allIndustries: [] as string[],
			allRegions: [] as string[],
			allTypes: [] as string[],
			matchRequest: {} as MatchRequest,
			matchFilterDto: {} as MatchFiltersDto,
			countryKeyValue: {} as Record<string, string>,
			industryKeyValue: {} as Record<string, string>,
			queryKeyValue: {} as Record<string, string>,
			typeKeyValue: {} as Record<string, string>,
			regionKeyValue: {} as Record<string, string>,
			currentPage: 0,
			pageSize: 10,
			isLoadingMore: false,
			hasMorePages: true,
			matchResultDetail: {
				unit: {
					id: 0,
					community: [] as {
						url: string,
						platform: string
					}[]
				}
			} as Match,
			community: [] as {
				url: string,
				platform: string
			}[],
			booths: [] as { 
				url: string
				name: string 
			}[],
			contactList: [] as UnitDto[],
			contactListRefactor: [] as {
				firstName: string,
				lastName: string,
				title: string[],
				email: string,
				mobilePhone: string,
				community: {
					url: string | null,
					platform: string | null
				}[]
			}[],
			matchResults: {} as MatchResultsDto,
			recommendedAction: {
				id: '' as string,
				title: '' as string,
				summary: '' as string,
				text: '' as string
			},
			userDto: {} as UserDto,
			sharingRequest: {} as SharingRequest,
			editorOptions: {
				hideModeSwitch: true,
				toolbarItems: [
					['heading', 'bold', 'italic', 'strike'],
					['hr', 'quote'],
					['ul', 'ol', 'task', 'indent', 'outdent'],
					['table', 'link'],
					['code', 'codeblock'],
					['scrollSync'],
				]
			},
			// 搜尋進度條相關
			isSearchLoading: false,
			progressValue: 0,
			progressStatusText: '',
			progressInterval: null as any
		};
	},
	computed: {
        isPublicIntro(): boolean { return publicIntro(this.trackDto?.id, false) },
        introLabel(): string { return introButtonText(this.$vuetify.breakpoint.xs) },
		trackDto(){
			return store.state.track.trackDto
		},
		user() {
			return store.state.user;
		}
	},
	methods: {
        async openIntroForm(item: any, source = 'results_card') {
            await this.matchContextReady;
            if (this.resultsDestroyed) return;
            this.matchResultDetail = item
            if (!this.isPublicIntro) { this.loginForSaveContact(); return }
            clearTimeout(this.detailDrawerTimer)
            this.detailDrawer = false; this.mobileDetailDrawer = false; this.loginPromptDialog = false
            this.introContextData = introContext(item, this.matchRequest, '', source)
            this.introOpen = true
        },
		capitalizeFirst(text: string): string {
			if (!text) return ''
			return text.charAt(0).toUpperCase() + text.slice(1)
		},
		onSearchStarted() {
			this.isSearchLoading = true
			this.progressValue = 0
			this.progressStatusText = String(this.$t('common.progressStatus.analyzingRequest'))

			// 啟動進度條動畫 - 15秒分成4等份
			let startTime = Date.now()

			this.progressInterval = setInterval(() => {
				const elapsed = Date.now() - startTime
				const timer = elapsed / 1000 // 轉換為秒

				if (timer >= 15) {
					// 超過15秒，保持在99%
					this.progressValue = 99
					this.progressStatusText = String(this.$t('common.progressStatus.generatingResults'))
					return
				}

				if (timer <= 3.75) {
					// 第一等分：分析您的需求
					this.progressStatusText = String(this.$t('common.progressStatus.analyzingRequest'))
					this.progressValue = (timer / 3.75) * 24.75  // 0-24.75%
				} else if (timer > 3.75 && timer <= 7.5) {
					// 第二等分：搜尋相關成員
					this.progressStatusText = String(this.$t('common.progressStatus.searchingMembers'))
					this.progressValue = 24.75 + ((timer - 3.75) / 3.75) * 24.75  // 24.75-49.5%
				} else if (timer > 7.5 && timer <= 11.25) {
					// 第三等分：智慧配對中
					this.progressStatusText = String(this.$t('common.progressStatus.smartMatching'))
					this.progressValue = 49.5 + ((timer - 7.5) / 3.75) * 24.75  // 49.5-74.25%
				} else if (timer > 11.25 && timer <= 15) {
					// 第四等分：生成結果
					this.progressStatusText = String(this.$t('common.progressStatus.generatingResults'))
					this.progressValue = 74.25 + ((timer - 11.25) / 3.75) * 24.75  // 74.25-99%
				}
			}, 100)  // 每100ms更新一次，讓動畫更平滑
		},
		onSearchFinished() {
			// 完成動畫 - 與 UserProfile.vue 相同的邏輯
			this.progressValue = 100
			clearInterval(this.progressInterval)
			setTimeout(() => {
				this.isSearchLoading = false
				this.progressValue = 0
				this.progressStatusText = ''
			}, 500)
		},
		async login() {
			if (this.isInWebView()) {
				alert(String(this.$t('nonLoginBusinessMatchResults.loginError')));
				return;
			}
			
			if (this.$route.params.tmpUserId) {
				localStorage.setItem('TMP_USER_ID', this.$route.params.tmpUserId);
			}

			localStorage.setItem('LOGIN_TO_PAGE', 'results');

			userManager.signinRedirect();
		},
		smoothScrollToTop() {
			const desktopContainer = this.$refs.desktopListContainer as HTMLElement;
			const mobileContainer = this.$refs.mobileListContainer as HTMLElement;
			const container = desktopContainer || mobileContainer;
			
			if (container) {
				const scrollDuration = 500;
				const startPosition = container.scrollTop;
				const startTime = performance.now();
				
				const easeInOutQuad = (t: number) => {
					return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
				};
				
				const animateScroll = (currentTime: number) => {
					const elapsed = currentTime - startTime;
					const progress = Math.min(elapsed / scrollDuration, 1);
					const easeProgress = easeInOutQuad(progress);
					
					container.scrollTop = startPosition * (1 - easeProgress);
					
					if (progress < 1) {
						requestAnimationFrame(animateScroll);
					}
				};
				
				requestAnimationFrame(animateScroll);
			}
		},
		async clearAllFilters() {
			this.overlay = true
			this.countries = []
			this.industries = []
			this.matchQueries = []
			this.regions = []
			this.isHasStructuredProfile = 'all'
			
			// 重置分頁狀態
			this.currentPage = 0
			this.hasMorePages = true
			
			await Promise.all([
				this.getMatches(),
				this.getFilterList()
			])
			this.overlay = false
		},
		handleScroll(event) {
			// 註解掉滾動載入更多功能
			// const element = event.target;
			// const scrollHeight = element.scrollHeight;
			// const scrollTop = element.scrollTop;
			// const clientHeight = element.clientHeight;

			// // 當滾動到底部附近時觸發載入更多
			// if (scrollHeight - scrollTop <= clientHeight + 100) {
			// 	this.loadMore();
			// }
		},
		async loadMore() {
			if (this.isLoadingMore || !this.hasMorePages) return;
			
			// 根據是否有篩選條件來決定使用哪個方法
			if (this.hasActiveFilters()) {
				await this.refine(true);
			} else {
				await this.getMatches(true);
			}
		},
		hasActiveFilters() {
			return (this.countries && this.countries.length > 0) ||
				(this.industries && this.industries.length > 0) ||
				(this.matchQueries && this.matchQueries.length > 0) ||
				(this.regions && this.regions.length > 0) ||
				this.isHasStructuredProfile !== 'all';
		},
		async handleFilterChange() {
			await Promise.all([
				this.getFilterList(),
				this.refine()
			])
		},
		normalizedWebsite(url: string) {
			if (!url) return ''; // 沒有網址就回傳空字串
			if (/^https?:\/\//i.test(url)) {
				return url;
			}
			return 'https://' + url;
		},
		isInWebView() {
			const ua = navigator.userAgent;
			return /FBAN|FBAV|Instagram|Line|Messenger|WebView/i.test(ua);
		},
		async loginForSaveContact(){
			if (this.isInWebView()) {
				alert(String(this.$t('nonLoginBusinessMatchResults.loginError')));
				return;
			}
			
			if (this.$route.params.tmpUserId) {
				localStorage.setItem('TMP_USER_ID', this.$route.params.tmpUserId);
			}

			localStorage.setItem('LOGIN_TO_PAGE', 'results');
			localStorage.setItem('MATCH_RESULTS_ID', this.matchResultDetail.id as string);
			localStorage.setItem('ACTION', 'save-contact');

			// userManager.signinRedirect();
			this.detailDrawer = false
			this.mobileDetailDrawer = false
			this.loginPromptDialogSource = 'default'
			this.loginPromptDialog = true
		},
		handleEditorChange() {
			const editorInstance = this.$refs.markdownEditor as InstanceType<typeof Editor>;
			this.emailContentMarkdownForEdit = editorInstance.invoke('getMarkdown');
		},
		copy(text) {
			copy(text)
			this.isCopied = true
			setTimeout(() => {
				this.isCopied = false
			}, 1000)
		},
		async share(){
			this.overlay = true
			let createResp
			try {
				let filterInput: FiltersInput = {
					countriesIso3: this.countries,
					industries: this.industries,
					queries: this.matchQueries,
					regions: this.regions,
					...(this.isHasStructuredProfile !== 'all' && {
						hasStructuredProfile: this.isHasStructuredProfile === 'true'
					})
				}

				filterInput.countriesIso3 = Object.entries(this.countryKeyValue ?? {})
					.filter(([key, value]) => this.countries?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});

				filterInput.industries = Object.entries(this.industryKeyValue ?? {})
					.filter(([key, value]) => this.industries?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});
				
				filterInput.queries = Object.entries(this.queryKeyValue ?? {})
					.filter(([key, value]) => this.matchQueries?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});

				filterInput.regions = Object.entries(this.regionKeyValue ?? {})
					.filter(([key, value]) => this.regions?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});
				
				createResp = await this.api$.sharingApi.create1(this.matchRequest.id as string, filterInput)
				this.sharingRequest = createResp.data.data

				this.sharingUrl = window.location.origin + '/nl-match/sharing/' + this.sharingRequest.id
				this.sharingDialog = true
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error(error);
			}
			this.overlay = false
		},
		async getMe(){
			try {
				const resp = await this.api$.authApi.getMe();
				this.userDto = resp.data.data as UserDto;

				// this.fistName = this.userDto.firstName ?? '';
				this.firstName = this.userDto.firstName === 'Guest' ? '' : (this.userDto.firstName ?? '');
				this.lastName = this.userDto.lastName === 'User' ? '' : (this.userDto.lastName ?? '');
				this.jobTitle = this.userDto.companyTitle?.[0] ?? '';
				// this.companyName = this.userDto.companyName ?? '';
				this.companyWebsiteUrl = this.userDto.companyUrl ?? '';

			} catch (e) {
				console.error(e);
			}
		},
		onImageError(item : Match) {
			if (item.unit && item.unit.entityName) {
				const firstLetter = item.unit.entityName?.charAt(0).toUpperCase() || "";
				item.unit.avatarUrl = require(`@/assets/business-match/alphabet/alphabet=${firstLetter}.png`);
			} else if(item.unit) {
				item.unit.avatarUrl = require('@/assets/business-match/alphabet/alphabet=Other.png');
			}
		},
		async getMatchRequest(){
			try {
				let getMatchRequestResp
				getMatchRequestResp = await getGuestMatchRequest(this.api$.businessMatchApi, this.$route.params.tmpUserId,
                    this.trackDto?.id || '0', localStorage.getItem('TMP_USER_EMAIL'))
				this.matchRequest = getMatchRequestResp.data.data
			}catch (error) {
                this.costCode = costGuardCode(error)
				console.error(error);
			}
		},
		async getMatches(isLoadMore = false, shouldScroll = true){
			if (this.isLoadingMore) return;
			if (isLoadMore && !this.hasMorePages) return;
            const requestSequence = ++this.resultRequestSequence;
            const requestUserId = this.$route.params.tmpUserId;
            const requestTrackId = this.trackDto?.id || '0';
            const isCurrent = () => !this.resultsDestroyed && this.resultRequestSequence === requestSequence
                && this.$route.params.tmpUserId === requestUserId && (this.trackDto?.id || '0') === requestTrackId;
            this.loadError = false;
            const previousPage = this.currentPage;
			
			if (isLoadMore) {
				this.isLoadingMore = true;
				this.currentPage++;
			} else {
				this.overlay = true;
				this.currentPage = 0;
				this.hasMorePages = true;
			}
			
			let getMatchesResp
			try {
				getMatchesResp = await this.api$.businessMatchApi.getMatchesPaginated(
					this.$route.params.tmpUserId, 
					this.trackDto?.id? this.trackDto.id : '0',
					this.currentPage,
					this.pageSize
				)
				if (!isCurrent()) return;
				
				const newData = getMatchesResp.data.data;
                if (getMatchesResp.data.isSuccess === false || !Array.isArray(newData?.content)) throw new Error('Invalid match response');
				
				if (isLoadMore) {
					// 追加新資料到現有列表
					if (newData.content && newData.content.length > 0) {
						this.matchResults.matches = (this.matchResults.matches || []).concat(newData.content);
					}
					this.hasMorePages = newData.content && newData.content.length === this.pageSize;
				} else {
					// 第一次載入或重新載入
					this.matchResults.matches = newData.content || [];
                    resultsRendered(this.trackDto?.id, newData.content?.length || 0);

					this.hasMorePages = newData.content && newData.content.length === this.pageSize;
					// 只有在 shouldScroll 為 true 時才滾動到頂部
					if (shouldScroll) {
						this.$nextTick(() => {
							this.smoothScrollToTop();
						});
					}
				}

				// 處理新載入的資料
				const matchesToProcess = isLoadMore ? newData.content : this.matchResults.matches;
				matchesToProcess?.forEach(match => {
					if (match.unit?.tags) {
						const parsed: any = JSON.parse(JSON.stringify(match.unit.tags));
						const chapterValue = parsed.chapter;
						const regionValue = parsed.region;
						const typeValue = parsed.type;

						match.unit.tags = JSON.parse(
							JSON.stringify({
								...(chapterValue != null && { chapter: chapterValue }),
								...(regionValue != null && { region: regionValue }),
								...(typeValue != null && { type: typeValue })
							})
						);
					}
				});

                // The full original results are usable immediately. Translation
                // updates a detached copy later without changing ranking or fields.
                void this.translateResultPage(matchesToProcess || []);
			} catch (error) {
                this.costCode = costGuardCode(error)
				if (!isCurrent()) return;
				console.error('Error fetching get matches:', error);
                this.loadError = true;
                if (isLoadMore) this.currentPage = previousPage;
			} finally {
				if (isCurrent() && isLoadMore) {
					this.isLoadingMore = false;
				} else if (isCurrent()) {
					this.overlay = false;
				}
			}
		},
        async translateResultPage(matches: Match[]) {
            if (!matches.length) return;
            const locale = i18n.locale;
            const language = locale === 'zh' ? 'zh-Hant' : locale === 'ja' ? 'ja' : locale === 'en' ? 'en-US' : null;
            if (!language) return;
            const translationSequence = this.resultTranslationSequence;
            const userId = this.$route.params.tmpUserId;
            const trackId = this.trackDto?.id || '0';
            const originals = matches.slice();
            try {
                const translated: Match[] = JSON.parse(JSON.stringify(originals));
                await translateMatches(translated, language);
                if (this.resultsDestroyed || this.resultTranslationSequence !== translationSequence || i18n.locale !== locale
                    || this.$route.params.tmpUserId !== userId || (this.trackDto?.id || '0') !== trackId) return;
                originals.forEach((original, offset) => {
                    const index = this.matchResults.matches?.indexOf(original) ?? -1;
                    if (index >= 0 && this.matchResults.matches) this.$set(this.matchResults.matches, index, translated[offset]);
                });
            } catch {
                // Translation is optional presentation data. Keep complete originals
                // available; a translation error is not a failed search response.
            }
        },
		async insertMatchResultDetail(match : Match){
			const requestSequence = ++this.detailRequestSequence
			const deadline = Date.now() + 10000
			let active = true
			let deadlineTimer: ReturnType<typeof setTimeout> | undefined
			let pollTimer: ReturnType<typeof setTimeout> | undefined
			let originalDetail: Match | null = null
			const isCurrent = () => active && this.detailRequestSequence === requestSequence
			this.overlay = true
			this.detailError = false
			this.detailDrawer = false
			this.mobileDetailDrawer = false
			this.currentDetailItem = match
			if (this.detailDrawerTimer) {
				clearTimeout(this.detailDrawerTimer)
				this.detailDrawerTimer = null
			}
			const loadDetail = async (): Promise<Match> => {
				let detail = JSON.parse(JSON.stringify(match)) as Match
				if (detail.summaries?.length) return detail
				let attempts = 0
				while(isCurrent() && Date.now() < deadline && attempts < 10){
					attempts++
					detail = await this.getMatch(match.id as string, Math.max(1, deadline - Date.now()))
					if (!isCurrent() || Date.now() >= deadline) throw new Error('Match detail request expired')
					if (detail.summaries?.length) break
					await new Promise(resolve => {
						pollTimer = setTimeout(resolve, Math.min(1000, Math.max(1, deadline - Date.now())))
					})
				}
				if (!isCurrent() || !detail.summaries?.length) throw new Error('Match details unavailable')
				originalDetail = JSON.parse(JSON.stringify(detail)) as Match
				const language = { zh: 'zh-Hant', en: 'en-US', ja: 'ja' }[i18n.locale]
				if (!language) return originalDetail
				const translatedDetail = JSON.parse(JSON.stringify(originalDetail)) as Match
				await translateMatch(translatedDetail, language)
				return translatedDetail
			}
			try {
				const expired = new Promise<Match>((resolve, reject) => {
					deadlineTimer = setTimeout(() => reject(new Error('Match detail request expired')), Math.max(0, deadline - Date.now()))
				})
				const detail = await Promise.race([loadDetail(), expired]).catch(error => {
					if (originalDetail) return originalDetail
					throw error
				})
				if (!isCurrent()) return
				this.matchResultDetail = detail
				this.community = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.community || [])) as { url: string; platform: string }[]
				this.booths = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.booths || [])) as { url: string; name: string }[]
				const allowedPlatforms = ['linkedin', 'twitter', 'whatsapp', 'github'];
				this.community = this.community.filter(item => allowedPlatforms.includes(item.platform));
				this.demandDescriptions = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.demands || [])).map((d) => d.description ?? d.description_short ?? d.descriptionShort);
				this.supplyDescriptions = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.supplies || [])).map((s) => s.description ?? s.description_short ?? s.descriptionShort);
				if (this.matchResultDetail.unit?.tags) {
					const parsed: any = JSON.parse(JSON.stringify(this.matchResultDetail.unit.tags));
					const chapterValue = parsed.chapter;
					const regionValue = parsed.region;
					const typeValue = parsed.type;
					this.matchResultDetail.unit.tags = JSON.parse(
						JSON.stringify({
							...(chapterValue != null && { chapter: chapterValue }),
							...(regionValue != null && { region: regionValue }),
							...(typeValue != null && { type: typeValue })
						})
					)
				}
				this.detailDrawer = true
				this.mobileDetailDrawer = true
				this.startLoginPromptTimer()
			} catch (error) {
                this.costCode = costGuardCode(error)
				if (isCurrent()) this.detailError = true
			} finally {
				active = false
				if (deadlineTimer !== undefined) clearTimeout(deadlineTimer)
				if (pollTimer !== undefined) clearTimeout(pollTimer)
				if (this.detailRequestSequence === requestSequence) this.overlay = false
			}
		},
		async getMatch(matchId: string, timeout = 10000): Promise<Match>{
			try{
				const getMatchResp = await this.api$.businessMatchApi.getMatch(this.$route.params.tmpUserId, matchId, { timeout })
				if (getMatchResp.data.isSuccess === false || !getMatchResp.data.data?.id) throw new Error('Invalid match detail response')
				return getMatchResp.data.data
			}catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Error fetching get match by Id:', error);
				throw error;
			}
		},
		async getContactList(unitId : number){
			let getContactListResp
			try{
				getContactListResp = await this.api$.businessMatchApi.getContactList(this.$route.params.tmpUserId, unitId)
				this.contactList = getContactListResp.data.data

				const allowedPlatforms = ['linkedin', 'twitter', 'whatsapp', 'github'];
				this.contactListRefactor = this.contactList.map(item => {
					if(this.community){
						this.community = this.community.filter(item => {
							return allowedPlatforms.includes(item.platform);
						});
					}
					return {
						firstName: item.firstName as string,
						lastName: item.lastName as string,
						title: item.title as string[],
						email: item.email as string,
						mobilePhone: item.mobilePhone as string,
						community: JSON.parse(JSON.stringify(item.community)).filter(item => {
							return allowedPlatforms.includes(item.platform);
						}) as { url: string | null; platform: string | null }[]
					}
				})
			}catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Error fetching get contact list:', error);
			}
		},
		async refine(isLoadMore = false, shouldScroll = true){
			if (this.isLoadingMore) return;
			if (isLoadMore && !this.hasMorePages) return;
			
			if (isLoadMore) {
				this.isLoadingMore = true;
				this.currentPage++;
			} else {
				this.overlay = true;
				this.currentPage = 0;
				this.hasMorePages = true;
			}

			let filterInput: FiltersInput = {
				countriesIso3: this.countries,
				industries: this.industries,
				queries: this.matchQueries,
				regions: this.regions,
				types: this.types,
				...(this.isHasStructuredProfile !== 'all' && {
					hasStructuredProfile: this.isHasStructuredProfile === 'true'
				})
			}

			filterInput.countriesIso3 = Object.entries(this.countryKeyValue ?? {})
				.filter(([key, value]) => this.countries?.includes(value))
				.map(([key]) => {
					const match = key.match(/^(.+?) \((\d+)\)$/)
					return match ? match[1] : key
				});

			filterInput.industries = Object.entries(this.industryKeyValue ?? {})
				.filter(([key, value]) => this.industries?.includes(value))
				.map(([key]) => {
					const match = key.match(/^(.+?) \((\d+)\)$/)
					return match ? match[1] : key
				});

			filterInput.queries = Object.entries(this.queryKeyValue ?? {})
				.filter(([key, value]) => this.matchQueries?.includes(value))
				.map(([key]) => {
					const match = key.match(/^(.+?) \((\d+)\)$/)
					return match ? match[1] : key
				});

			filterInput.regions = Object.entries(this.regionKeyValue ?? {})
				.filter(([key, value]) => this.regions?.includes(value))
				.map(([key]) => {
					const match = key.match(/^(.+?) \((\d+)\)$/)
					return match ? match[1] : key
				});

			filterInput.types = Object.entries(this.typeKeyValue ?? {})
				.filter(([key, value]) => this.types?.includes(value))
				.map(([key]) => {
					const match = key.match(/^(.+?) \((\d+)\)$/)
					return match ? match[1] : key
				});

			let getMatchesWithFiltersResp
			try {
				getMatchesWithFiltersResp = await this.api$.businessMatchApi.getMatchesWithFiltersPaginated(
					this.$route.params.tmpUserId, 
					filterInput, 
					this.trackDto?.id? this.trackDto.id : '0',
					this.currentPage,
					this.pageSize
				)
				
				const newData = getMatchesWithFiltersResp.data.data;
				
				if (isLoadMore) {
					// 追加新資料到現有列表
					if (newData.content && newData.content.length > 0) {
						this.matchResults.matches = (this.matchResults.matches || []).concat(newData.content);
					}
					this.hasMorePages = newData.content && newData.content.length === this.pageSize;
				} else {
					// 第一次載入或重新載入
					this.matchResults.matches = newData.content || [];
                    resultsRendered(this.trackDto?.id, newData.content?.length || 0);
					this.hasMorePages = newData.content && newData.content.length === this.pageSize;
					// 只有在 shouldScroll 為 true 時才滾動到頂部
					if (shouldScroll) {
						this.$nextTick(() => {
							this.smoothScrollToTop();
						});
					}
				}

				// 處理新載入的資料
				const matchesToProcess = isLoadMore ? newData.content : this.matchResults.matches;
				matchesToProcess?.forEach(match => {
					if (match.unit?.tags) {
						const parsed: any = JSON.parse(JSON.stringify(match.unit.tags));
						const chapterValue = parsed.chapter;
						const regionValue = parsed.region;
						const typeValue = parsed.type;

						match.unit.tags = JSON.parse(
							JSON.stringify({
								...(chapterValue != null && { chapter: chapterValue }),
								...(regionValue != null && { region: regionValue }),
								...(typeValue != null && { type: typeValue })
							})
						);
					}
				});

				if (i18n.locale === 'zh') {
					await translateMatches(this.matchResults.matches || [], 'zh-Hant')
				} else if (i18n.locale === 'en') {
					await translateMatches(this.matchResults.matches || [], 'en-US')
				} else if (i18n.locale === 'ja') {
					await translateMatches(this.matchResults.matches || [], 'ja')
				}
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Error fetching get matches with filters:', error);
			} finally {
				if (isLoadMore) {
					this.isLoadingMore = false;
				} else {
					this.overlay = false;
				}
			}

			this.loginPromptDialogSource = 'refine'
			this.loginPromptDialog = true
		},
		async getFilterList() {
			let getMatchFilters
			try{
				// 先保存當前選擇的原始鍵值（不包含數字）
				const selectedCountryKeys = Object.entries(this.countryKeyValue ?? {})
					.filter(([key, value]) => this.countries?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});

				const selectedIndustryKeys = Object.entries(this.industryKeyValue ?? {})
					.filter(([key, value]) => this.industries?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});
				
				const selectedQueryKeys = Object.entries(this.queryKeyValue ?? {})
					.filter(([key, value]) => this.matchQueries?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});

				const selectedRegionKeys = Object.entries(this.regionKeyValue ?? {})
					.filter(([key, value]) => this.regions?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});

				const selectedTypeKeys = Object.entries(this.typeKeyValue ?? {})
					.filter(([key, value]) => this.types?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});

				let filterInput: FiltersInput = {
					countriesIso3: selectedCountryKeys,
					industries: selectedIndustryKeys,
					queries: selectedQueryKeys,
					regions: selectedRegionKeys,
					types: selectedTypeKeys,
					...(this.isHasStructuredProfile !== 'all' && {
						hasStructuredProfile: this.isHasStructuredProfile === 'true'
					})
				}

				getMatchFilters = await this.api$.businessMatchApi.getMatchFilters(
					this.$route.params.tmpUserId,
					filterInput,
					this.trackDto?.id ? this.trackDto.id : '0'
				)
				this.matchFilterDto = getMatchFilters.data.data

				this.countryKeyValue = this.normalizeToKeyValue(this.matchFilterDto.countries) ?? {}
				this.industryKeyValue = this.normalizeToKeyValue(this.matchFilterDto.industries) ?? {}
				this.queryKeyValue = this.normalizeToKeyValue(this.matchFilterDto.queries) ?? {}
				this.regionKeyValue = this.normalizeToKeyValue(this.matchFilterDto.regions) ?? {}
				this.typeKeyValue = this.normalizeToKeyValue(this.matchFilterDto.types) ?? {}

				if (i18n.locale === 'zh') {
					await Promise.all([
						translateRecordValues(this.countryKeyValue, 'zh-Hant'),
						translateRecordValues(this.industryKeyValue, 'zh-Hant'),
						translateRecordValues(this.queryKeyValue, 'zh-Hant'),
						translateRecordValues(this.regionKeyValue, 'zh-Hant'),
						translateRecordValues(this.typeKeyValue, 'zh-Hant')
					])
				} else if (i18n.locale === 'en') {
					await Promise.all([
						translateRecordValues(this.countryKeyValue, 'en-US'),
						translateRecordValues(this.industryKeyValue, 'en-US'),
						translateRecordValues(this.queryKeyValue, 'en-US'),
						translateRecordValues(this.regionKeyValue, 'en-US'),
						translateRecordValues(this.typeKeyValue, 'en-US')
					])
				} else if (i18n.locale === 'ja') {
					await Promise.all([
						translateRecordValues(this.countryKeyValue, 'ja-JP'),
						translateRecordValues(this.industryKeyValue, 'ja-JP'),
						translateRecordValues(this.queryKeyValue, 'ja-JP'),
						translateRecordValues(this.regionKeyValue, 'ja-JP'),
						translateRecordValues(this.typeKeyValue, 'ja-JP')
					])
				}

				this.allCountries = Object.values(this.countryKeyValue ?? {})
				this.allMatchQueries = Object.values(this.queryKeyValue ?? {});
				this.allIndustries = Object.values(this.industryKeyValue ?? {})
				this.allRegions = Object.values(this.regionKeyValue ?? {})
				this.allTypes = Object.values(this.typeKeyValue ?? {})

				// 重新映射選擇的項目到新的值（包含更新後的數字）
				this.countries = Object.entries(this.countryKeyValue ?? {})
					.filter(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						const keyWithoutNumber = match ? match[1] : key
						return selectedCountryKeys.includes(keyWithoutNumber)
					})
					.map(([key, value]) => value)

				this.industries = Object.entries(this.industryKeyValue ?? {})
					.filter(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						const keyWithoutNumber = match ? match[1] : key
						return selectedIndustryKeys.includes(keyWithoutNumber)
					})
					.map(([key, value]) => value)

				this.matchQueries = Object.entries(this.queryKeyValue ?? {})
					.filter(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						const keyWithoutNumber = match ? match[1] : key
						return selectedQueryKeys.includes(keyWithoutNumber)
					})
					.map(([key, value]) => value)

				this.regions = Object.entries(this.regionKeyValue ?? {})
					.filter(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						const keyWithoutNumber = match ? match[1] : key
						return selectedRegionKeys.includes(keyWithoutNumber)
					})
					.map(([key, value]) => value)

				this.types = Object.entries(this.typeKeyValue ?? {})
					.filter(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						const keyWithoutNumber = match ? match[1] : key
						return selectedTypeKeys.includes(keyWithoutNumber)
					})
					.map(([key, value]) => value)
			}catch (error) {
                this.costCode = costGuardCode(error)
				console.error(error);
			}
		},
		normalizeToKeyValue(data: any): Record<string, string> | undefined {
			if (Array.isArray(data)) {
				return data.reduce((acc: Record<string, string>, item: any) => {
					if (typeof item === 'string') {
						acc[item] = item;
					}
					return acc;
				}, {});
			}
			if (typeof data === 'object' && data !== null) {
				const values = Object.values(data);
				if (values.every(v => Array.isArray(v))) {
					return values.reduce((acc: Record<string, string>, arr: any) => {
						arr.forEach((item: any) => {
							if (typeof item === 'string') {
								acc[item] = item;
							}
						});
						return acc;
					}, {});
				} else {
					return data;
				}
			}
			return undefined;
		},
		async getEmail(matchId){
			this.overlay = true
			this.emailDialog = false

			let fistName = this.firstName.length == 0 ? undefined : this.firstName
			let lastName = this.lastName.length == 0 ? undefined : this.lastName
			let jobTitle = this.jobTitle.length === 0 ? undefined : [this.jobTitle]
			// let companyName = this.companyName.length == 0 ? undefined : this.companyName
			let companyWebsiteUrl = this.companyWebsiteUrl.length == 0 ? undefined : 'https://' + this.companyWebsiteUrl

			const ProfileUpdatedRequest: ProfileUpdatedRequest = {
				firstName: fistName,
				lastName: lastName,
				companyTitle: jobTitle,
				// companyName: companyName,
				companyUrl: companyWebsiteUrl,
				productTrackId: this.trackDto?.id,
				isDelete: this.userDto?.isDelete,
			}

			let getRecommendedActionsResp
			let updateProfileResp
			try{
				updateProfileResp = await this.api$.profileApi.updateProfile(this.$route.params.tmpUserId, ProfileUpdatedRequest)

				getRecommendedActionsResp = await this.api$.businessMatchApi.getRecommendedActions(this.$route.params.tmpUserId, matchId, localStorage.getItem('locale') ?? 'en', this.trackDto?.id? this.trackDto.id : '0')
				this.recommendedAction = getRecommendedActionsResp.data.data

				const editorInstance = this.$refs.markdownEditor as InstanceType<typeof Editor>;
				if(editorInstance){
					editorInstance.invoke('setMarkdown', this.recommendedAction.text as string);
				}else{
					this.emailContentMarkdownForEdit = this.recommendedAction.text as string
				}

				this.emailDialog = true
			}catch (error) {
                this.costCode = costGuardCode(error)
				console.error(error);
			}
			this.overlay = false
		},
		async downloadCSV(){
			const trackId = this.trackDto?.id || ''
			const tmpUserId = this.$route.params.tmpUserId;
			try {
				const downloadUrl = process.env.VUE_APP_API_BASE_URL+`/api/user/${tmpUserId}/business-match/download-match-results?productTrackId=${trackId}`;
				window.open(downloadUrl, '_blank');
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Error downloading CSV:', error);
			}
		},
		async handleRadioChange(value: string) {
			this.overlay = true
			this.countries = []
			this.industries = []
			this.matchQueries = []
			this.matchDirections = []
			this.regions = []
			await Promise.all([
				this.getFilterList(),
				this.refine()
			])
			this.overlay = false
		},
		startLoginPromptTimer() {
			if (this.isPublicIntro) return
			// Clear existing timer if any
			if (this.detailDrawerTimer) {
				clearTimeout(this.detailDrawerTimer)
			}

			// Start 30-second timer
			this.detailDrawerTimer = setTimeout(() => {
				this.detailDrawer = false
				this.mobileDetailDrawer = false
				this.loginPromptDialogSource = 'default'
				this.loginPromptDialog = true
			}, 30000)
		},
		clearLoginPromptTimer() {
			if (this.detailDrawerTimer) {
				clearTimeout(this.detailDrawerTimer)
				this.detailDrawerTimer = null
			}
		}
	},
	async created(){
		this.overlay = true
        this.matchContextReady = this.getMatchRequest();
		await Promise.all([
			this.matchContextReady,
			this.getMe(),
			this.getMatches(),
			this.getFilterList()
		])
		this.overlay = false
	},
	mounted() {
		// 監聽搜尋事件
		this.eventHub$.$on('searchStarted', this.onSearchStarted)
		this.eventHub$.$on('searchFinished', this.onSearchFinished)
	},
	beforeDestroy() {
		this.resultsDestroyed = true
		this.resultRequestSequence++
		this.resultTranslationSequence++
		this.detailRequestSequence++
		this.clearLoginPromptTimer()
		// 移除 eventHub 監聽器
		this.eventHub$.$off('searchStarted', this.onSearchStarted)
		this.eventHub$.$off('searchFinished', this.onSearchFinished)
	},
	watch: {
		detailDrawer(newVal) {
			if (!newVal) {
				// Drawer closed, clear timer
				this.clearLoginPromptTimer()
			}
		},
		'$i18n.locale': {
			immediate: false,
			async handler() {
				this.resultTranslationSequence++
				this.overlay = true
				
				// 只翻譯現有資料，不重新呼叫 API
				if (this.matchResults.matches && this.matchResults.matches.length > 0) {
					if (i18n.locale === 'zh') {
						await translateMatches(this.matchResults.matches, 'zh-Hant')
					} else if (i18n.locale === 'en') {
						await translateMatches(this.matchResults.matches, 'en-US')
					} else if (i18n.locale === 'ja') {
						await translateMatches(this.matchResults.matches, 'ja')
					}
				}
				
				// 翻譯 filter 資料
				if (this.matchFilterDto) {
					const selectedCountryKeys = Object.entries(this.countryKeyValue ?? {})
						.filter(([key, value]) => this.countries?.includes(value))
						.map(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							return match ? match[1] : key
						});

					const selectedIndustryKeys = Object.entries(this.industryKeyValue ?? {})
						.filter(([key, value]) => this.industries?.includes(value))
						.map(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							return match ? match[1] : key
						});
					
					const selectedQueryKeys = Object.entries(this.queryKeyValue ?? {})
						.filter(([key, value]) => this.matchQueries?.includes(value))
						.map(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							return match ? match[1] : key
						});

					const selectedRegionKeys = Object.entries(this.regionKeyValue ?? {})
						.filter(([key, value]) => this.regions?.includes(value))
						.map(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							return match ? match[1] : key
						});

					const selectedTypeKeys = Object.entries(this.typeKeyValue ?? {})
						.filter(([key, value]) => this.types?.includes(value))
						.map(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							return match ? match[1] : key
						});

					if (i18n.locale === 'zh') {
						await Promise.all([
							translateRecordValues(this.countryKeyValue, 'zh-Hant'),
							translateRecordValues(this.industryKeyValue, 'zh-Hant'),
							translateRecordValues(this.queryKeyValue, 'zh-Hant'),
							translateRecordValues(this.regionKeyValue, 'zh-Hant'),
							translateRecordValues(this.typeKeyValue, 'zh-Hant')
						])
					} else if (i18n.locale === 'en') {
						await Promise.all([
							translateRecordValues(this.countryKeyValue, 'en-US'),
							translateRecordValues(this.industryKeyValue, 'en-US'),
							translateRecordValues(this.queryKeyValue, 'en-US'),
							translateRecordValues(this.regionKeyValue, 'en-US'),
							translateRecordValues(this.typeKeyValue, 'en-US')
						])
					} else if (i18n.locale === 'ja') {
						await Promise.all([
							translateRecordValues(this.countryKeyValue, 'ja-JP'),
							translateRecordValues(this.industryKeyValue, 'ja-JP'),
							translateRecordValues(this.queryKeyValue, 'ja-JP'),
							translateRecordValues(this.regionKeyValue, 'ja-JP'),
							translateRecordValues(this.typeKeyValue, 'ja-JP')
						])
					}

					this.allCountries = Object.values(this.countryKeyValue ?? {})
					this.allMatchQueries = Object.values(this.queryKeyValue ?? {});
					this.allIndustries = Object.values(this.industryKeyValue ?? {})
					this.allRegions = Object.values(this.regionKeyValue ?? {})
					this.allTypes = Object.values(this.typeKeyValue ?? {})

					// 重新映射選擇的項目到新的值（包含更新後的數字）
					this.countries = Object.entries(this.countryKeyValue ?? {})
						.filter(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							const keyWithoutNumber = match ? match[1] : key
							return selectedCountryKeys.includes(keyWithoutNumber)
						})
						.map(([key, value]) => value)

					this.industries = Object.entries(this.industryKeyValue ?? {})
						.filter(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							const keyWithoutNumber = match ? match[1] : key
							return selectedIndustryKeys.includes(keyWithoutNumber)
						})
						.map(([key, value]) => value)

					this.matchQueries = Object.entries(this.queryKeyValue ?? {})
						.filter(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							const keyWithoutNumber = match ? match[1] : key
							return selectedQueryKeys.includes(keyWithoutNumber)
						})
						.map(([key, value]) => value)

					this.regions = Object.entries(this.regionKeyValue ?? {})
						.filter(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							const keyWithoutNumber = match ? match[1] : key
							return selectedRegionKeys.includes(keyWithoutNumber)
						})
						.map(([key, value]) => value)

					this.types = Object.entries(this.typeKeyValue ?? {})
						.filter(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							const keyWithoutNumber = match ? match[1] : key
							return selectedTypeKeys.includes(keyWithoutNumber)
						})
						.map(([key, value]) => value)
				}
				
				this.overlay = false
			}
		}
	}
});
